import { revealHiddenAddressFields } from './validation/validation.helpers.js';
import { initDonationAmount } from './macmillan.utils.js';
import {
    fixIPhoneApostrophes,
    formatPostalCode,
    postCodeToUpperCase,
    handleBackButton,
    formatDonorPhoneNumber
} from './common/utils.js';


/**
 * Replaces the first word in a given string with a specified word.
 *
 * @param {string} word - The word to replace the first word of the string.
 * @param {string} string - The original string where the first word will be replaced.
 * @returns {string} - The modified string with the first word replaced.
 */
const replaceFirstWordOfString = (word, string) => {
    // Use a regular expression to find the first word
    return string.replace(/^\S+/, word);
}

/**
 * Handles changes to the organisation type selection in the donation form.
 * 
 * This function sets up event listeners on the organisation type dropdown.
 * When the selection changes, it updates the visibility and content of
 * related form fields based on the selected organisation type.
 * 
 * - If "Home" is selected, the gift aid section is shown and the organisation
 *   name field is hidden and cleared.
 * - If "School" is selected, the organisation name label is updated to start
 *   with "School".
 * - For other selections, the organisation name label is updated to start
 *   with "Organisation".
 * - If the selection is empty, the organisation name field is hidden.
 * 
 * Additionally, it triggers a blur event on the organisation name field
 * unless the selected value is "Company", "Group", or "School".
 */
const handleOrganisationTypeChange = () => {
    $('select#Donation_Organisation_OrganisationType').on('change', function () {
        const eventLocation = $("#Donation_Organisation_OrganisationType").val();
        const orgNameLabel = $('.org-name label').text();
        $('#Donation_Organisation_Name').val('');
        if (eventLocation == "Home") {
            $('.gift-aid').removeClass('hidden');
            $('.org-name').addClass('hidden');
            $('#Donation_Organisation_Name').val('');
        } else {
            $('.gift-aid').addClass('hidden');
            $('#GiftAid').attr('checked', false);
            $('.org-name').removeClass('hidden');
            if (eventLocation == "School") {
                $('.org-name label').text(replaceFirstWordOfString('School', orgNameLabel));
            } else {
                $('.org-name label').text(replaceFirstWordOfString('Organisation', orgNameLabel));
            }
            if (eventLocation == "") {
                $('.org-name').addClass('hidden');
            }
        }
        $('#Donation_Organisation_Name').focus();
    });

    $('#Donation_Organisation_OrganisationType').on('change', function () {
        const selectedValue = $("#Donation_Organisation_OrganisationType").val();
        if (!(selectedValue == "Company" || selectedValue == "Group" || selectedValue == "School")) {
            $('#Donation_Organisation_Name').trigger('blur');
        }
    })
}

/**
 * Copies the donor's address and contact information to the organisation's fields
 * when the 'copyBillingAddress' checkbox is checked. It also triggers validation
 * for each copied field in the form.
 */
const copyBillingAddress = () => {
    $('#copyBillingAddress').on('change', function (e) {
        if (this.checked) {

            // Reveal any address fields hidden behind an "enter manually"
            // button so their values are copied across too.
            document
                .querySelectorAll('.js-enter-address-manually')
                .forEach(button => revealHiddenAddressFields(e, button, false));

            const validator = $(".wbcmform").validate();
            const sourceFieldsValid =
                validator.element("#Donation_Donor_Title") !== false &&
                validator.element("#Donation_Donor_FirstName") !== false &&
                validator.element("#Donation_Donor_LastName") !== false &&
                validator.element("#Donation_Donor_Address_PostalTown") !== false &&
                validator.element("#Donation_Donor_Address_FirstLine") !== false &&
                validator.element("#Donation_Donor_Address_SecondLine") !== false &&
                validator.element("#Donation_Donor_Address_PostalCode") !== false;

            if (!sourceFieldsValid) {
                this.checked = false;
                $('#copyBillingAddress-error').text('Please correct the errors in your personal details before copying.').removeClass('hidden');
                return;
            }

            $("#Donation_Organisation_Title").val($("#Donation_Donor_Title").val());
            $('#copyBillingAddress-error').text('').addClass('hidden');

            $("#Donation_Organisation_Firstname").val($("#Donation_Donor_FirstName").val());
            $("#Donation_Organisation_Lastname").val($("#Donation_Donor_LastName").val());
            $("#Donation_Organisation_Address_PostalCode").val($("#Donation_Donor_Address_PostalCode").val());
            $("#Donation_Organisation_Address_FirstLine").val($("#Donation_Donor_Address_FirstLine").val());
            $("#Donation_Organisation_Address_SecondLine").val($("#Donation_Donor_Address_SecondLine").val());
            $("#Donation_Organisation_Address_ThirdLine").val($("#Donation_Donor_Address_ThirdLine").val());
            $("#Donation_Organisation_Address_PostalTown").val($("#Donation_Donor_Address_PostalTown").val());
            $("#Donation_Organisation_Address_CountyProvince").val($("#Donation_Donor_Address_CountyProvince").val());
            $("#Donation_Organisation_Phone_Number").val($("#Donation_Donor_Phone_Number").val());

            validator.element("#Donation_Organisation_Title");
            validator.element("#Donation_Organisation_Firstname");
            validator.element("#Donation_Organisation_Lastname");
            validator.element("#Donation_Organisation_Address_PostalCode");
            validator.element("#Donation_Organisation_Address_FirstLine");
            validator.element("#Donation_Organisation_Address_SecondLine");
            validator.element("#Donation_Organisation_Address_PostalTown");
            validator.element("#Donation_Organisation_Phone_Number");
        }
    });
}

const bindWbcmEvents = () => {

    handleOrganisationTypeChange();

    copyBillingAddress();

    formatDonorPhoneNumber();

    postCodeToUpperCase();

    formatPostalCode('#Postcode');

    handleBackButton();

    fixIPhoneApostrophes();

}

const initWbcmDonationsForm = () => {
    bindWbcmEvents();
}


const initOneOffDonationJourney = () => {
    const addressGroup = $('.donation-journey').find('#Donor\\.Address\\.selected');
    const enterManualAddress = document.querySelector(".donation-journey .donation_enterManualAddress a");

    if (addressGroup.length > 0) {
        addressGroup[0].style.display = "none";
        addressGroup[0].style.paddingTop = 0;
    }

    // Validate that the user has attempted to find an address
    function validateAddressSelection() {
        const postcodeCheck = $('#address_selection_check');
        // A jQuery object is always returned, so no truthiness guard is needed;
        // remove() on an empty set is a no-op.
        postcodeCheck.next('messagebox js').remove();
        postcodeCheck.val("true");
        $(postcodeCheck).valid();
    }

    if (enterManualAddress) {
        enterManualAddress.addEventListener("click", function (e) {
            e.preventDefault();
            validateAddressSelection();
            addressGroup[0].style.display = "block";
            enterManualAddress.parentElement.style.display = "none";
        });
    }

    // One off donation - A BIG THANK YOU page - Facebook share script
    function facebookShare(e, params) {
        e.preventDefault();

        $.getScript('//connect.facebook.net/en_UK/all.js', function () {
            FB.init({
                appId: '281996246305932',
                version: '2.12'
            });
            FB.ui({
                method: 'share',
                href: params.url,
                quote: params.quoteText
            });
        });
    }

    $('#ThankYouButtonFacebook').on('click', function (e) {

        const json = {
            url: "http://www.macmillan.org.uk/Donate/",
            quoteText: null
        };

        facebookShare(e, json);
    });
}

$(() => {
    initWbcmDonationsForm();
    initDonationAmount();
    initOneOffDonationJourney();
})
